"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var useIsStarted_1 = __importDefault(require("./useIsStarted"));
var useTimer_1 = __importDefault(require("./useTimer"));
var MarkupText_1 = __importDefault(require("../../../../localization/components/MarkupText"));
var TimeBase = function (props) {
    var endTime = props.endTime, startTime = props.startTime;
    var isStarted = (0, useIsStarted_1.default)(startTime);
    var tickerDate = isStarted ? endTime : startTime;
    var tickerTextId = isStarted ? "timeLimit" : "startsIn";
    var _a = (0, useTimer_1.default)(tickerDate), time = _a.time, completed = _a.completed;
    if (completed) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(MarkupText_1.default, { id: tickerTextId, values: { value: time } }));
};
var updateFunc = function (nextProps, prevProps) {
    return nextProps.startTime === prevProps.startTime && nextProps.endTime === prevProps.endTime;
};
exports.default = react_1.default.memo(TimeBase, updateFunc);
